import http from '../lib/http-common';
import authGuestHeader from "./authGuestHeader";

let API_URL = process.env.REACT_APP_BACKEND_URL + '/api/';

const getPeacecoinTeam = () => {
    return http.get(API_URL + 'team')
}

const getCoins = () => {
    return http.get(API_URL + 'coins')
}

const getDigitalMarketingPackages = () => {
    return http.get(API_URL + 'digital-marketing')
}

const getNfts = () => {
    return http.get(API_URL + 'nfts')
}

const getJewelry = () => {
    return http.get(API_URL + 'jewelry')
}

const getApparels = () => {
    return http.get(API_URL + 'apparels')
}

const getBlogs = () => {
    return http.get(API_URL + 'blogs')
}

const getBlogDetails = (id) => {
    return http.get(API_URL + `blog/${id}/details`)
}

const storeContact = (data) => {
    return http.post(API_URL + "contact", data);
}

const createOrder = (data) => {
    return http.post(API_URL + "order", data);
}

const getOrderDetails = (orderId) => {
    return http.get(API_URL + "order/details/" + orderId);
}

const getTaxShippingCharges = () => {
    return http.get(API_URL + "shipping/charges");
}

const updateGuestProfile = (data, guestId) => {
    return http.post(API_URL + "guest/profile/" + guestId, data, { headers: authGuestHeader() });
}

const changePassword = (data) => {
    return http.post(API_URL + "guest/password", data, { headers: authGuestHeader() });
}

const getOrders = () => {
    return http.get(API_URL + "guest/orders", { headers: authGuestHeader() });
}

const getDashboardOrderDetails = (orderId) => {
    return http.get(API_URL + "guest/order/" + orderId + "/details", { headers: authGuestHeader() });
}

const getTransactions = () => {
    return http.get(API_URL + "guest/transactions", { headers: authGuestHeader() });
}

const getPageContent = (slug) => {
    return http.get(API_URL + "page/" + slug + "/content");
}

const getUserAndJoiningPackages = (username) => {
    return http.get(API_URL + "user-and-joining-packages/" + username);
}

const guestService = {
    getPeacecoinTeam,
    getCoins,
    getDigitalMarketingPackages,
    getNfts,
    getJewelry,
    getApparels,
    getBlogs,
    getBlogDetails,
    storeContact,
    createOrder,
    getOrderDetails,
    getTaxShippingCharges,
    updateGuestProfile,
    changePassword,
    getOrders,
    getDashboardOrderDetails,
    getTransactions,
    getPageContent,
    getUserAndJoiningPackages
};

export default guestService;